

import {useContext, useEffect, useState} from 'react';
import FlujosEstructureContext from 'context/FlujosEstructureContext';
import {
 getAll,
 create,
 update,
 del
} from 'services/FlujosEstructureService.js'
import Swal from 'sweetalert2'


let totalPages;


export function useFlujosEstructure(){
 const [page, setPage] = useState(1);
 const [itemsPerPage, setItemsPerPage] = useState(5)

 const {
  allFlujosEstructure, 
  setAllFlujosEstructure,
  flujosEstructure, 
  setFlujosEstructure, 
  setMessage, 
  message,
  loading, 
  setLoading} = useContext(FlujosEstructureContext);

 
 const getAllFlujosEstructure = async ({nivel}) => {
  try{
   const response = await getAll({nivel});
   setAllFlujosEstructure(response)
   return response
  }catch(err){
   const {data, status} = err.response;
   setMessage({message: data.message, status});
  }
 }

 const getFlujosEstructure = async ({page = 1, limit = itemsPerPage, nivel}) => {
     setLoading(true);
     setPage(page);
     try{
         const allFlujosEstructure = await getAllFlujosEstructure({nivel});
         setAllFlujosEstructure(allFlujosEstructure);
         totalPages = Math.ceil(allFlujosEstructure.length / limit);
         const flujosEstructure = await getAll({page, limit, nivel});
         setFlujosEstructure(flujosEstructure);
         setLoading(false);
     }catch(err){
         console.log(err);
         const {data, status} = err.response;
         setMessage({message: data.message, status})
         setLoading(false);
     }
 }

 const deleteFlujoEstructure = async ({id}) => {
     Swal.fire({
     title: 'Estás seguro?',
     text: '¡No podrás revertir esto!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Si, eliminar!',
     cancelButtonText: 'Cancelar'
     }).then((result) => {
     if (result.isConfirmed) {
        (async() => {
            try{
                const {message} = await del({id})
                setMessage({message: '', status: 200})
                
                Swal.fire(
                'Éxito!!!',
                message,
                'success'
                )
                getFlujosEstructure({page})
            }catch(err){
                const {data, status} = err.response
                setMessage({message: data.message, status})
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.message,
                })
            }
        })();
    }
    })
 }

 const updateFlujoEstructure = async ({flujo, id}) => {
    try{
        const {message} = await update({flujo, id})
        setMessage({message: '', status: 200})
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getFlujosEstructure({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 const createFlujoEstructure = async ({flujo}) => {
     try{
        const {message} = await create({flujo})
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getFlujosEstructure({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 useEffect(() => {
  getFlujosEstructure({});
  // eslint-disable-next-line
 }, [])

 return {
    allFlujosEstructure,
    flujosEstructure,
    page,
    totalPages,
    status: message.status,
    loading,
    deleteFlujoEstructure,
    updateFlujoEstructure,
    createFlujoEstructure,
    getFlujosEstructure,
    setPage,
    itemsPerPage,
    setItemsPerPage
 }
}